const CardAlertBase = (props) => {
  const { cardFields, children } = props;

  return (
    <div className="ui-card mt-3 rounded-none">
      <div className="px-3 py-3 lg:p-5">
        <div
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7
         xl:gap-9"
        >
          {cardFields.map((cardField, index) => {
            const { title, value } = cardField;
            return (
              <div key={`cardFields${index}`}>
                <div className="text-xs text-theme-text-tertiary">{title}</div>
                <div className="text-sm font-semibold text-theme-text-secondary">
                  {value}
                </div>
              </div>
            );
          })}
          {children}
        </div>
      </div>
    </div>
  );
};

export default CardAlertBase;
